import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
import { NotificationProvider } from "../../context/NotificationContext";

export default function ProtectedRoutes() {
  const { isAuthenticated } = useAuthContext();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <NotificationProvider>
      <Outlet />
    </NotificationProvider>
  );
}
